const GREEN = "#68d751";
const PURPLE = "#6179e5";
const TEAL = "#35f3e0";
const RED = "#ffa8a4";
export { GREEN, PURPLE, TEAL, RED };
